"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Middleware_helpers_1 = require("../Middleware.helpers");
/**
 * App Config Middleware will dynamically inject host in all request
 * We can also customize custom host by different kinda of requests.
 * @param sessionConfig
 */
var apiConfigMiddleware = function (apiConfig) { return function () { return function (next) { return function (action) {
    var isHttpAction = Middleware_helpers_1.contains(apiConfig.actions, action.type);
    var queryKey = isHttpAction && action.queryKey;
    var apiEndpointByQueryKey = queryKey &&
        apiConfig.apiEndpointsByQueryKey &&
        apiConfig.apiEndpointsByQueryKey[queryKey];
    // Inject the host info in all requests
    if (isHttpAction) {
        if (apiConfig.byPass && apiConfig.byPass(action)) {
            return next(action);
        }
        var nextAction = __assign(__assign({}, action), { url: "" + (apiEndpointByQueryKey || apiConfig.defaultApiEndpoint) + action.url });
        return next(nextAction);
    }
    else {
        return next(action);
    }
}; }; }; };
exports.default = apiConfigMiddleware;
//# sourceMappingURL=ApiConfigMiddleware.js.map